import React, { useEffect } from "react";
import BatteryStatusIcon from "assets/svgIcons/AdminDashboard/BatteryStatus";
import OutOfServiceIconWithoutBorder from "assets/svgIcons/AdminDashboard/OutOfServiceIconWithoutBorder";
import BatteryIcon from "assets/svgIcons/BatteryWithPowerIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { siteId } from "redux/reduxToolkitServices/_commonApiCalls/api";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import {
  GlobalCourseIdState,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";
const BatteryNotification = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const {
    getDashboardBatteryNotificationState,
    siteSettingsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state?.commonReducers) || [];

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      const currQueryDate = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DD");
      dispatch(
        COMMON_SERVICES.getDashboardBatteryNotificationServices(
          siteId.get(),
          currQueryDate,
          localStorage.getItem("dashCourseId")
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    siteId.get(),
    localStorage.getItem("dashCourseId"),
    siteSettingsData,
  ]);

  return (
    <>
      <div className="header">
        <BatteryIcon color="#666" width={22} height={12} />
        <p className="blue-border">{t("Battery_Notification")}</p>
      </div>
      <div className="box-body battery-notification-section">
        <div>
          <div>
            <div className="battery-wrapper-section">
              <h3>
                {getDashboardBatteryNotificationState &&
                  getDashboardBatteryNotificationState[0]?.Oncharge}
                <span>
                  <BatteryStatusIcon />
                </span>
              </h3>
              <h3>
                {getDashboardBatteryNotificationState &&
                  getDashboardBatteryNotificationState[0]?.NotonCharge}
                <span>
                  <BatteryStatusIcon color="#FA3C30" />
                </span>
              </h3>
            </div>
            <p>{t("Battery_status")}</p>
          </div>
          <div>
            <div>
              <h3>
                {getDashboardBatteryNotificationState &&
                  getDashboardBatteryNotificationState[0]?.OutofService}
                <span>
                  <OutOfServiceIconWithoutBorder />
                </span>
              </h3>
            </div>
            <p>{t("Out_of_service")}</p>
          </div>
          <div>
            {getDashboardBatteryNotificationState &&
            getDashboardBatteryNotificationState[0]?.AllCarOnCharge !== null ? (
              <h3>{getDashboardBatteryNotificationState[0]?.AllCarOnCharge}</h3>
            ) : (
              <></>
            )}
            <p>{t("Cars_on_charge")}</p>
          </div>
          <div>
            {getDashboardBatteryNotificationState &&
            getDashboardBatteryNotificationState[0]?.LastTimeCharge !== null ? (
              <h3>
                {moment
                  .utc(getDashboardBatteryNotificationState[0]?.LastTimeCharge)
                  .utcOffset(-siteSettingsData?.TimeZoneOffset)
                  .format("LT")}
              </h3>
            ) : (
              <></>
            )}
            <p>{t("Last_car_on_charge")}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BatteryNotification;
